import Api from '../api';
import type { ProposalResponse } from './ai_management_proposal';

export type ProposalCheckOrigem = 'edital' | 'cliente' | 'basica' | 'declaracoes';
export type ProposalCheckStatus =
  | 'atendida'
  | 'nao_atendida'
  | 'requer_atencao'
  | 'ciente'
  | 'a_conferir'
  | 'conferida';
export type ProposalCheckOndeCorrigir =
  | 'regras'
  | 'itens'
  | 'empresa'
  | 'condicoes'
  | 'declaracoes';

export interface ProposalCheckItemResponse {
  regra: string;
  origem: ProposalCheckOrigem;
  status: ProposalCheckStatus;
  detalhe: string | null;
  trecho: string | null;
  onde_corrigir: ProposalCheckOndeCorrigir | null;
  campo_alvo: unknown;
  ciente: boolean | null;
}

export interface ProposalCheckResponse {
  itens: ProposalCheckItemResponse[];
  contadores: {
    atendidas: number;
    requer_atencao: number;
    nao_atendidas: number;
    total: number;
  };
  pode_gerar: boolean;
}

export type ProposalCheckPatch = { ciente: boolean } | { conferida: boolean };

const basePath = (biddingId: number) => `/gestao_ia/licitacoes/${biddingId}/proposta`;

export const getProposalCheck = (biddingId: number) =>
  Api.get<ProposalCheckResponse>(`${basePath(biddingId)}/checagem`);

// Responde a checagem inteira, já recalculada.
export const updateProposalCheck = (biddingId: number, regra: string, patch: ProposalCheckPatch) =>
  Api.patch<ProposalCheckResponse>(
    `${basePath(biddingId)}/checagem/${encodeURIComponent(regra)}`,
    patch,
  );

export const reviewProposal = (biddingId: number) =>
  Api.post<ProposalResponse>(`${basePath(biddingId)}/revisar`);
